<template>
  <CRow>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="loading">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-if="!loading">
      <CCardBody>
        <CRow>
          <CCol sm="6">
            <label>Title</label>
            <CInput
              v-b-tooltip="tooltip.title"
              type="text"
              placeholder="title"
              v-model="title"
            />
          </CCol>
          <CCol sm="6">
            <label>Enter the Description</label>
            <CInput
              v-b-tooltip="tooltip.description"
              type="text"
              placeholder="Enter the  Description"
              v-model="description"
            />
          </CCol>
          <CCol sm="6">
            <label>Game Average Score</label>
            <CInput
              v-b-tooltip="tooltip.averageScore"
              type="number"
              placeholder="Game Average Score"
              v-model.number="averageScore"
            />
          </CCol>
          <CCol sm="6">
            <label>Thumbnail</label>
            <CInput
              v-b-tooltip="tooltip.thumbnail"
              type="text"
              placeholder="Thumbnail Url"
              v-model="thumbnail"
            />
          </CCol>
          <CCol sm="6">
            <label>CoverImage URL</label>
            <CInput
              v-b-tooltip="tooltip.coverImage"
              type="text"
              placeholder="CoverImage URL"
              v-model="coverImage"
            />
          </CCol>

          <CCol sm="6">
            <label>Game URL</label>
            <CInput
              v-b-tooltip="tooltip.url"
              type="text"
              placeholder="Game URL"
              v-model="url"
            />
          </CCol>
          <CCol sm="12">
            <h6>Add Game Rules</h6>
            <div class="form-group" v-for="(input, k) in this.rules" :key="k">
              <CRow>
                <CCol sm="6">
                  <input
                    v-if="k == 0"
                    v-b-tooltip="tooltip.rules"
                    type="text"
                    class="form-control"
                    placeholder="Rule...."
                    v-model.number="rules[k]"
                  />
                  <input
                    v-if="k != 0"
                    type="text"
                    class="form-control"
                    placeholder="Rule...."
                    v-model.number="rules[k]"
                  />
                </CCol>
                <CCol sm="2">
                  <span>
                    <CButton
                      color="danger"
                      @click="removeRules(k)"
                      v-show="k || (!k && rules.length > 1)"
                    >
                      <i class="fa fa-times"></i
                    ></CButton>
                    &nbsp;&nbsp;&nbsp;
                    <CButton
                      color="success"
                      @click="addRules()"
                      v-show="k == rules.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i
                    ></CButton>
                  </span>
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <h6>Variable Pay Rules</h6>
            <div
              class="form-group"
              v-for="(input, k) in this.variablePayRules"
              :key="k"
            >
              <CRow>
                <CCol sm="6">
                  <input
                    v-if="k == 0"
                    v-b-tooltip="tooltip.variablePayRules"
                    type="text"
                    class="form-control"
                    placeholder="Tournament rules...."
                    v-model.number="variablePayRules[k]"
                  />
                  <input
                    v-if="k != 0"
                    type="text"
                    class="form-control"
                    placeholder="Variable Pay Rules...."
                    v-model.number="variablePayRules[k]"
                  />
                </CCol>
                <CCol sm="2">
                  <span>
                    <CButton
                      color="danger"
                      @click="removevariablePayRules(k)"
                      v-show="k || (!k && variablePayRules.length > 1)"
                    >
                      <i class="fa fa-times"></i
                    ></CButton>
                    &nbsp;&nbsp;&nbsp;
                    <CButton
                      color="success"
                      @click="addvariablePayRules()"
                      v-show="k == variablePayRules.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i
                    ></CButton>
                  </span>
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <CRow>
              <CCol sm="4">
                <span
                  v-b-tooltip="tooltip.isFixedPayout"
                  style="font-size: 14px; font-weight: bold"
                  >FixedPayout</span
                >

                <input
                  v-b-tooltip="tooltip.isFixedPayout"
                  v-model="isFixedPayout"
                  type="checkbox"
                  value="isFixedPayout"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span
                  v-b-tooltip="tooltip.isNftUtilEnabled"
                  style="font-size: 14px; font-weight: bold"
                  >Nft Utility Enable</span
                >
                <input
                  v-model="isNftUtilEnabled"
                  v-b-tooltip="tooltip.isNftUtilEnabled"
                  type="checkbox"
                  value="isNftUtilEnabled"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="12" v-if="isNftUtilEnabled">
            <h3>Add NFT</h3>

            <CRow v-for="(nft, i) in this.nfts" :key="i">
              <CCol sm="4">
                <label>NFT Contract Address</label>
                <CInput
                  type="text"
                  v-b-tooltip="tooltip.NftcontractAddress"
                  v-model="nft.contractAddress"
                  placeholder="Contract Address"
                />
              </CCol>
              <CCol sm="4">
                <label>Standard</label>
                <CSelect
                  v-b-tooltip="tooltip.Nftstandard"
                  class=""
                  size="sm"
                  v-model="nft.standard"
                  placeholder="Select a Select Standard"
                  :options="nftStandards"
                />
                <!-- <CInput
                  v-on:change="nftStandard(i)"
                  v-model="nft.standard"
                  type="text"
                  placeholder="NFT Standard"
                /> -->
              </CCol>
              <CCol sm="4" class="d-flex align-items-center">
                <CButton
                  class="mx-1"
                  color="success"
                  style="width: 50%"
                  @click="addNft()"
                  >Add</CButton
                >
                <CButton
                  v-if="nfts.length > 1"
                  class="mx-1"
                  color="danger"
                  style="width: 50%"
                  @click="deleteNft(i)"
                  >Delete</CButton
                >
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="12">
            <h3>Choose a Platform</h3>
            <CRow class="mt-3">
              <CCol sm="4">
                <span
                  v-b-tooltip="tooltip.isAndroid"
                  style="font-size: 14px; font-weight: bold"
                  >Android</span
                >
                <input
                  v-model="isAndroid"
                  v-b-tooltip="tooltip.isAndroid"
                  type="checkbox"
                  value="isAndroid"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span
                  v-b-tooltip="tooltip.isWeb"
                  style="font-size: 14px; font-weight: bold"
                  >Web</span
                >
                <input
                  v-model="isWeb"
                  v-b-tooltip="tooltip.isWeb"
                  type="checkbox"
                  value="isWeb"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span
                  v-b-tooltip="tooltip.isIos"
                  style="font-size: 14px; font-weight: bold"
                  >IOS</span
                >
                <input
                  v-model="isIos"
                  v-b-tooltip="tooltip.isIos"
                  type="checkbox"
                  value="isIos"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>

          <CCol sm="12">
            <h3>Tokens</h3>
            <div class="form-group" v-for="(input, k) in this.tokens" :key="k">
              <CRow>
                <CCol sm="6">
                  <label> Token name</label>
                  <CInput
                    v-b-tooltip="tooltip.tokenName"
                    type="text"
                    disabled
                    v-model="input.name"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Token Icon</label>
                  <CInput
                    v-b-tooltip="tooltip.TokenIcon"
                    type="text"
                    placeholder="Token Icon"
                    v-model="input.icon"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Token ContractAddress</label>
                  <CInput
                    v-b-tooltip="tooltip.TokencontractAddress"
                    type="text"
                    placeholder="Token ContractAddress"
                    v-model="input.contractAddress"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Payout Maximum Percentage</label>
                  <CInput
                    v-b-tooltip="tooltip.varPayMaxPer"
                    type="number"
                    placeholder="Enter the Payout Maximum Percentage"
                    v-model.number="input.varPayMaxPer"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Payout Minimum Percentage</label>
                  <CInput
                    v-b-tooltip="tooltip.varPayMinPer"
                    type="number"
                    placeholder="Enter the Payout Minimum Percentage"
                    v-model.number="input.varPayMinPer"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Token Minimum Variable Fee</label>
                  <CInput
                    v-b-tooltip="tooltip.minVarFee"
                    type="number"
                    placeholder="Minimum Variable Fee"
                    v-model.number="input.minVarFee"
                  />
                </CCol>

                <CCol sm="12" class="d-flex justify-content-center">
                  <CButton
                    color="danger"
                    class="w-25 my-2"
                    style="width: 50%"
                    @click="deleteToken(input.name)"
                    >Delete Token</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <h5>Add Token to the Game</h5>
          </CCol>
          <CCol sm="6">
            <CInput
              v-b-tooltip="tooltip.tokenName"
              type="text"
              placeholder="Token Name in Capital"
              v-model="tokenName"
            />
          </CCol>
          <CCol sm="6">
            <CButton color="success" style="width: 50%" @click="addToken()"
              >Add Token Details</CButton
            >
          </CCol>
          <CCol sm="12">
            <h2>Categories</h2>
          </CCol>

          <CCol
            sm="2"
            class="mb-2 d-flex align-items-center"
            v-for="(input, k) in this.categories"
            :key="k"
            v-if="input.name != 'All'"
          >
            <input
              class="mx-3"
              v-model="selectedCategory"
              type="radio"
              v-bind:value="input.name"
              name="gameCategory"
            />
            <span
              v-b-tooltip="tooltip.categories"
              style="font-size: 14px; font-weight: bold"
              >{{ input.name }}</span
            >
            <br />
            <br />
          </CCol>

          <CCol sm="12" style="text-align: center !important">
            <CButton color="success" style="width: 20%" @click="saveGame()"
              >Save</CButton
            >
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CRow>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import Vue from "vue";
import { VBTooltip } from "bootstrap-vue";
Vue.directive("b-tooltip", VBTooltip);

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      loading: true,
      description: "",
      isFixedPayout: false,
      isAndroid: false,
      isWeb: false,
      averageScore: 0,
      title: "",
      thumbnail: "",
      isIos: false,
      rules: [""],
      tokenName: "",
      coverImage: "",
      url: "",
      tokens: {},
      variablePayRules: [""],
      categories: [],
      isNftUtilEnabled: false,
      selectedCategory: null,
      id: "",
      nfts: [
        {
          contractAddress: "",
          standard: null,
        },
      ],
      nftStandards: ["ERC-721", "ERC-1155"],
      tooltip: {
        title: "Enter the title for your Game",
        description: "Enter a Description for your Game",
        averageScore:
          "Details on Average Scores are required for gaming calculations. A new user who plays a game for the first time will have no average score limitations. Once a user starts playing a certain game frequently, their score will be decided under a calculation formula.",
        thumbnail:
          "Enter thumbnail image URL of your game. Thumbnail will appear on homescreen or games category screen on Scrim as a small game icon.",
        coverImage:
          "Enter cover image URL of your game. Cover Image will appear on a specific game screen or Banner.",
        url: "Enter the URL link for your game",
        rules:
          "Enter Rules for your Games (Eg: Reward Limit, Maximum Earnings, Refund & etc..)",
        variablePayRules:
          "Enter Rules for your Game’s Entry Fee and Payment Reward Structure (Eg: Min and Max Entry participation Fee, Type of Token that users can play with and etc..)",
        isFixedPayout:
          "Enable if your game is a win/lose type of game. Scores are unconsidered in fixed payout games",
        isIos: "Enable if your game should be integrated on iOs",
        isAndroid: "Enable if your game should be integrated on Android",
        isWeb: "Enable if your game should be integrated on Web",
        tokens: "Enter name of the Token that players can use",
        categories:
          "Select Category for your Game.. Your Game will appear under the chosen Category.",
        isNftUtilEnabled:
          "Enable if your NFT has gaming utilities which will allow users to buy, play with and claim certain utilities. Once this is enabled, please add NFT details below",
        tokenName: "Enter name of the Token",
        NftcontractAddress: "Enter NFT contact address",
        Nftstandard: "Select NFT Standard Type",
        TokenIcon: "Enter URL for Token Icon",
        TokencontractAddress: "Enter the Contact Address of your Token",
        varPayMaxPer:
          "Enter the maximum percentage that users will be allowed to earn after each game.",
        varPayMinPer:
          "Enter the minimum percentage based on token fee. Users will earn regardless of their points scored.",
        minVarFee:
          "Enter minimum entry fee amount (Variable fee will allow users to play with an entry fee of their choice)",
      },
    };
  },
  methods: {
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    changeDateUpdate() {
      this.isDateUpdate = true;
    },
    startTimeDateUpdate() {
      this.isstartTimeDateUpdate = true;
      this.startTime = "";
    },
    endTimeDateUpdate() {
      this.isEndTimeDateUpdate = true;
      this.endTime = "";
    },
    extraPayTimeDateUpdate() {
      this.isExtraPayTimeUpdate = true;
      this.extraPayTime = "";
    },
    allowFreeUpdate() {
      this.isAllowFreeUpdate = true;
      this.allowFree = [
        {
          endTime: "",
          startTime: "",
        },
      ];
    },
    async getCategories() {
      this.tableData = [];

      // console.log("firebase.auth().currentUser.getIdToken()", token);

      await db
        .collection("gameConfig")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (
              doc.data().name != "New" &&
              doc.data().name != "1 vs 1" &&
              doc.data().name != "Free"
            ) {
              let data = doc.data();
              data.isInclude = doc.data().name == "All" ? true : false;
              this.categories.push(data);
            }
          });
        })
        .catch((e) => console.log("errror", e));
      //   console.log("categitesss", this.categories);
    },
    getDataByID(id) {
      db.collection("gamesCategoriesV2")
        .doc(id)
        .get()
        .then((snapshot) => {
          // console.log("snapshot", snapshot);
          if (snapshot.exists) {
            this.rules = snapshot.data().rules;
            this.description = snapshot.data().description;
            this.isFixedPayout = snapshot.data().fixedPayout;
            this.isAndroid = snapshot.data().isAndroid;
            this.isWeb = snapshot.data().isWeb;
            this.averageScore = snapshot.data().initialPerdayAverage;
            this.title = snapshot.data().title;
            this.thumbnail = snapshot.data().thumbnail;
            this.isIos = snapshot.data().isIos;
            this.rules = snapshot.data().rules;
            this.coverImage = snapshot.data().coverImage;
            this.url = snapshot.data().url;

            this.tokens = snapshot.data().tokens;
            this.nfts = snapshot.data().nfts;
            this.isNftUtilEnabled = snapshot.data().isNftUtilEnabled;
            this.variablePayRules = snapshot.data().variablePayRules;
            let categoriesFilter = [];
            categoriesFilter = snapshot.data().categories;
            categoriesFilter.map((el) => {
              if (el != "All") {
                this.selectedCategory = el;
              }
            });
            // this.categories.map((el) => {

            //   if (categoriesFilter.includes(el.name)) {
            //     el.isInclude = true;
            //   }
            // });
          }
          this.loading = false;
          //   console.log("snapshot.data()", snapshot.data());
        })
        .catch((e) => {
          console.log("errror", e);
          this.loading = false;
        });
    },

    async saveGame() {
      let categoriesFilter = [];
      this.categories.forEach((e) => {
        // Temporary fixing code
        if (e.name != this.selectedCategory && e.name != "All") {
          e.isInclude = false;
        }
        if (this.selectedCategory == e.name) {
          e.isInclude = true;
        }
        if (e.isInclude == true) {
          categoriesFilter.push(e.name);
        }
      });
      if (!this.isNftUtilEnabled) {
        this.nfts = [
          {
            contractAddress: "",
            standard: null,
          },
        ];
      }
      if (
        this.description == "" ||
        this.title == "" ||
        this.thumbnail == "" ||
        this.coverImage == "" ||
        this.url == ""
      ) {
        this.showMessage("Some fields are Missing, try again", "warning");
        return;
      }
      if (this.rules[this.rules.length - 1] == "") {
        this.showMessage("Game Rules are  Missing", "warning");
        return;
      }

      if (this.variablePayRules[this.variablePayRules.length - 1] == "") {
        this.showMessage("Variable Pay Rules are  Missing", "warning");
        return;
      }
      if (
        this.isNftUtilEnabled &&
        this.nfts.some((e) => e.contractAddress == "" || e.standard == null)
      ) {
        this.showMessage("NFT Fields are Missing ", "warning");
        return;
      }

      // if (this.nfts.length > 0 && !this.isNftUtilEnabled) {
      //   this.showMessage("Nft Utility Enable Must be checked ", "warning");
      //   return;
      // }

      if (Object.keys(this.tokens).length == 0) {
        this.showMessage(
          "Must be add atleast one token for add Game",
          "warning"
        );
        return;
      }
      if (this.selectedCategory == null) {
        this.showMessage("Select one Category for add Game", "warning");
        return;
      }
      this.loading = true;

      const token = await firebase.auth().currentUser.getIdToken();

      const headers = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "x-access-token": token,
        },
      };
      try {
        const response = await axios.put(
          "https://us-central1-token-geomine.cloudfunctions.net/apiTest/updateGameAdmin",
          {
            docId: this.id,
            gameData: {
              description: this.description,
              categories: categoriesFilter,
              createdTime: firebase.firestore.Timestamp.fromDate(new Date()),
              fixedPayout: this.isFixedPayout,
              isAndroid: this.isAndroid,
              isWeb: this.isWeb,
              averageScore: this.averageScore,
              title: this.title,
              thumbnail: this.thumbnail,
              isIos: this.isIos,
              rules: this.rules,
              coverImage: this.coverImage,
              url: this.url,
              tokens: this.tokens,
              variablePayRules: this.variablePayRules,
              isNftUtilEnabled: this.isNftUtilEnabled,
              nfts: this.nfts,
            },
          },
          headers
        );
        console.log("response", response);
        if (response.data.Status == true) {
          this.loading = false;
          this.showMessage("Updated Successfully", "success");
          this.$router.push({
            name: "Games",
          });
          // this.updateData();
        } else {
          this.loading = false;
          this.showMessage("Error while Saving Game", "warning");
        }
      } catch (error) {
        this.loading = false;
        console.log("error", error);
        this.showMessage("Error while Updating Game", "warning");
      }
    },
    addToken() {
      if (this.tokenName === "" && this.tokenName.indexOf(" ") >= 0) return;
      this.tokenName = this.tokenName.toUpperCase().trim();
      this.tokens[this.tokenName] = {
        name: this.tokenName,
        thumbnail: "",
        contractAddress: "",
        minVarFee: 0,
        varPayMaxPer: 0,
        varPayMinPer: 0,
        icon: "",
        isDynamic: true,
        isToken: false,
      };

      this.tokenName = "";
      this.$forceUpdate();
    },

    deleteToken(key) {
      delete this.tokens[key];
      this.$forceUpdate();
    },
    addNft() {
      this.nfts.push({
        contractAddress: "",
        standard: null,
      });
    },

    deleteNft(index) {
      if (this.nfts.length <= 1) return;
      this.nfts.splice(index, 1);
    },

    addRules() {
      this.rules.push("");
    },
    removeRules(index) {
      this.rules.splice(index, 1);
    },
    removevariablePayRules(index) {
      this.variablePayRules.splice(index, 1);
    },
    addvariablePayRules() {
      this.variablePayRules.push("");
    },
  },
  created() {
    this.id = this.$route.params.id;
    // console.log("this.id", this.id);
    this.getCategories();
    this.getDataByID(this.id);
  },
};
</script>

<style>
label {
  font-size: 16px;
  font-weight: 500;
}
</style>